module.exports = __webpack_public_path__ + "img/huawei_08.79524e50.jpg";